<template>
  <div>
    <div style="margin-bottom: 24px;">
      <div class="title hide-on-small-only">
        <h4>Usuários</h4>
        <div style="display: flex;">
          <a
            class="waves-effect waves-light btn"
            style="margin-right: 16px;"
            @click="openFilter = true"
          >
            <i class="material-icons">filter_alt</i>
          </a>
          <router-link
            tag="a"
            v-show="checkModulePermission('user', 'create')"
            class="waves-effect waves-light btn"
            :to="{ name: 'user-create' }"
          >
            <i class="material-icons">add</i>
          </router-link>
        </div>
      </div>

      <a
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        style="bottom: 88px;"
        @click="openFilter = true"
      >
        <i class="material-icons">filter_alt</i>
      </a>
      <router-link
        tag="a"
        v-show="checkModulePermission('user', 'create')"
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        :to="{ name: 'user-create' }"
      >
        <i class="material-icons">add</i>
      </router-link>

      <div class="hide-on-small-only">
        <table>
          <thead>
            <th>Nome</th>
            <th>Email</th>
            <th
              width="150px"
              v-show="checkModulePermission('user', 'edit')"
            ></th>
          </thead>
          <tbody>
            <tr v-if="!users.data.length > 0">
              <td colspan="6" class="center-align">
                {{
                  loadItens
                    ? "Buscando Clientes..."
                    : "Nenhum cliente cadastrado"
                }}
              </td>
            </tr>
            <tr v-else v-for="user in users.data" :key="user.uuid">
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td v-show="checkModulePermission('user', 'edit')">
                <div id="has-button-disabled">
                  <router-link
                    class="waves-effect waves-light btn btn-icon"
                    tag="a"
                    :to="{ name: 'user-edit', params: { id: user.uuid } }"
                  >
                    <i class="material-icons">edit</i>
                  </router-link>
                  <disabled-item-button
                    :id="user.uuid"
                    @click="disabled(user.uuid, user.active == 1)"
                    :active="!!user.active"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          v-if="users.data"
          :total-pages="totalPages"
          @changePage="changePage"
          :current-page="currentPage"
        />
      </div>

      <div class="box-list hide-on-med-and-up">
        <ul class="collection">
          <li v-if="!users.data.length > 0" class="white default-item">
            <p>
              {{
                loadItens ? "Buscando Clientes..." : "Nenhum cliente cadastrado"
              }}
            </p>
          </li>
          <li
            v-else
            class="collection-item avatar"
            v-for="user in users.data"
            :key="user.uuid"
          >
            <div class="collection-item__text">
              <span class="title">{{ user.name }}</span>
              <p>
                <b>Email:</b>
                {{ user.email }}
              </p>
            </div>
            <div
              class="collection-item__actions"
              v-show="checkModulePermission('user', 'edit')"
            >
              <router-link
                class="waves-effect waves-light btn btn-icon"
                style="margin-bottom: 10px"
                tag="a"
                :to="{ name: 'user-edit', params: { id: user.uuid } }"
              >
                <i class="material-icons">edit</i>
              </router-link>
              <disabled-item-button
                :id="user.uuid"
                @click="disabled(user.uuid, user.active == 1)"
                :active="!!user.active"
              />
            </div>
          </li>
          <li
            v-if="totalPages > 0 && currentPage !== totalPages"
            @click="changePage(currentPage + 1)"
            class="white default-item get-itens"
          >
            <feather v-if="loadItens" type="loader" animation="spin" />
            <p v-else>Buscar mais itens</p>
          </li>
        </ul>
      </div>
    </div>

    <VSideSlider
      :open="openFilter"
      @close="openFilter = false"
      title="Filtro de Clientes"
    >
      <div slot="body">
        <div class="row">
          <div class="input-field col s12">
            <label for="name">Nome</label>
            <input type="text" name="name" id="name" v-model="filter.name" />
          </div>
          <div class="input-field col s12">
            <label for="email">Email</label>
            <input type="text" name="email" id="email" v-model="filter.email" />
          </div>
        </div>
      </div>
      <div slot="actions">
        <div class="row">
          <div class="col s12 m6 s-mb-16">
            <button
              class="waves-effect btn-large flat form-button"
              @click="clearFilter"
            >
              Limpar
            </button>
          </div>
          <div class="col s12 m6">
            <button
              class="waves-effect waves-light btn-large form-button"
              @click="handleFilter"
              :class="{ load: loadFilter }"
            >
              <feather v-if="loadFilter" type="loader" animation="spin" />
              <template v-else
                >Filtrar</template
              >
            </button>
          </div>
        </div>
      </div>
    </VSideSlider>
  </div>
</template>

<script>
import { mapState } from "vuex";
import checkModulePermission from "@/services/mixins/checkModulePermission";

export default {
  name: "Users",
  mixins: [checkModulePermission],
  components: {
    VSideSlider: () => import("@/components/VSideSlider")
  },
  data: () => ({
    loadItens: false,
    openFilter: false,
    loadFilter: false,
    currentPage: 1,
    totalPages: 0,
    filter: {
      name: "",
      email: ""
    },
    users: {
      data: []
    }
  }),
  mounted() {
    this.getUsers();
  },
  computed: {
    ...mapState("User", ["token"])
  },
  methods: {
    clearFilter() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = "";
        this.$el.querySelector(`label[for=${key}]`).classList.remove("active");
      });

      this.openFilter = false;
      this.getUsers(1);
    },
    async handleFilter() {
      this.loadFilter = true;

      let query = Object.keys(this.filter).reduce((curr, keyFilter) => {
        if (this.filter[keyFilter]) {
          return curr + `${keyFilter}:${this.filter[keyFilter]};`;
        }

        return curr;
      }, "&search=");

      if (query != "&search=")
        await this.getUsers(
          1,
          query.includes(";") ? query.substring(0, query.length - 1) : query
        );

      this.loadFilter = false;
      this.openFilter = false;
    },
    async getUsers(page, query = "") {
      const pageSearch = page || this.currentPage;

      let url = `users?page=${pageSearch}` + query;

      try {
        this.loadItens = true;
        const response = await this.$http.get(url, {
          headers: {
            Authorization: this.token
          }
        });
        this.loadItens = false;
        const { users } = response.body.data;
        this.users = users;
        this.totalPages = users.meta.total;
      } catch (e) {
        console.error(e);
      }
    },
    async changePage(payload) {
      await this.getUsers(payload);
      this.currentPage = payload;
    },
    disabled(id, active) {
      this.$swal({
        title: "Tem certeza?",
        text: "Este item será desabilitado.",
        icon: "warning",
        buttons: {
          back: {
            text: "Cancelar"
          },
          confirm: {
            text: "Continuar",
            value: "ACTION",
            closeModal: false
          }
        }
      })
        .then(async v => {
          if (v === "ACTION") {
            try {
              await this.$http.post(
                `users/${id}`,
                {
                  user: {
                    active: active ? 0 : 1
                  }
                },
                {
                  headers: {
                    Authorization: `bearer ${this.token}`
                  }
                }
              );
              const el = document.getElementById(id);

              this.users.data = this.users.data.map(val => {
                if (val.uuid === id) {
                  return {
                    ...val,
                    active: active ? 0 : 1
                  };
                }

                return val;
              });

              if (active) el.classList.remove("active");
              else el.classList.add("active");

              this.$swal.stopLoading();
              this.$swal.close();
            } catch (e) {
              throw e;
            }
          }

          return null;
        })
        .catch(err => {
          if (err) {
            this.$swal(
              "Opss..",
              "Falha ao se comunicar com servidor, tente novamente mais tarde",
              "error"
            );
          } else {
            this.$swal.stopLoading();
            this.$swal.close();
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.collection-item.avatar {
  p {
    word-break: break-all;
  }
}

.form-button {
  width: 100%;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  @media #{$small-and-down} {
    padding: 16px 24px;
    a {
      height: 100%;
      width: 100%;
    }
  }
}
.box-list {
  padding: 0 16px;
}
.circle {
  position: relative !important;
  top: 50%;
  transform: translateY(-50%);
}
@media #{$small-and-down} {
  .collection-item {
    .title {
      padding: 10px 0 !important;
    }
  }
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 48px;
  }
}
.default-item {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.get-itens {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}
</style>
